var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Detail"},[_c('my_content',{attrs:{"content":_vm.detail.content,"inputStyle":_vm.detailStyle}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }